import React, { useEffect, useMemo, useRef, useState } from 'react';
import HookForm from '../../components/HookForm/HookForm';
import Select from '../../components/Select/Select';
import SelectMarks from '../../components/Selects/SelectMarks';
import SelectModels from '../../components/Selects/SelectModels';
import SelectComplectations from '../../components/Selects/SelectComplectations';
import SelectColor, { COLORS } from '../../components/Selects/SelectColor';
import SelectCity from '../../components/Selects/SelectCity';
import SelectWithFetch from '../../components/Selects/SelectWithFetch';
import getTransmissions from '../../api/shop/getTransmissions';
import getContainers from '../../api/cars/getContainers';
import getDcList from '../../api/cars/getDcList';
import AddModelModal from './AddModelModal';
import { decomposeOrigin } from './useOriginOptions';
import styles from './stockPendingRowsTable.module.css';

const ENGINE_TYPE_OPTIONS = ['ÐÐµÐ½Ð·Ð¸Ð½', 'ÐÐ¸Ð·ÐµÐ»Ñ', 'Ð­Ð»ÐµÐºÑÑÐ¾', 'ÐÐ¸Ð±ÑÐ¸Ð´'].map((label) => ({
  value: label,
  label,
}));
// ÐÐ¾ÑÐ¾Ð±ÐºÐ¸ Ð±ÐµÑÑÐ¼ Ð¸Ð· ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ°, Ð° Ð½Ðµ Ð¸Ð· ÐºÐ¾Ð½ÑÑÐ°Ð½ÑÑ: ÑÐ¿Ð¸ÑÐ¾Ðº Ð²ÐµÐ´ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ
// Ð¼Ð°ÑÐ¸Ð½Ñ, Ð¸ Ð·Ð°ÑÐ°ÑÐ´ÐºÐ¾Ð¶ÐµÐ½Ð½ÑÐ¹ Ð½Ð°Ð±Ð¾Ñ Ñ Ð½Ð¸Ð¼ ÑÐ°Ð·ÑÐµÐ·Ð¶Ð°Ð»ÑÑ (Ð½Ð° Ð¿ÑÐ¾Ð´Ðµ ÑÐ°Ðº Ð¿Ð¾ÑÐ²Ð¸Ð»Ð°ÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ
// Â«8 ÐÐ¢Â», ÐºÐ¾ÑÐ¾ÑÑÑ ÑÑÐ¾Ðº-Ð·Ð°Ð³ÑÑÐ·ÐºÐ° Ð½Ðµ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°Ð»Ð°). ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ â title, Ð° Ð½Ðµ id: Ð±ÑÐº Ð¼Ð°ÑÑÐ¸Ñ
// ÐÐÐ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ (FindTransmissionId), id ÐµÐ¼Ñ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½
const transmissionOption = (item) => ({ value: item.title, label: item.title });
const RowTransmissionSelect = (props) => (
  <SelectWithFetch fetch={getTransmissions} formatOption={transmissionOption} {...props} />
);

const findByName = (list, name, nameKey) => {
  if (!name) return null;
  return list.find((item) => (item[nameKey] || '').toLowerCase() === name.toLowerCase()) || null;
};

// ÐÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ ÐÐ¦ Ð½Ð° ÑÑÑÐ¾ÐºÑ â components/Selects/SelectDc.jsx Ð² Ð¿ÑÐ¾ÐµÐºÑÐµ Ð²ÑÐµÐ³Ð´Ð°
// Ð¼ÑÐ»ÑÑÐ¸ÑÐµÐ»ÐµÐºÑ (Ð¼Ð°ÑÐ¸Ð½Ð° Ð¼Ð¾Ð¶ÐµÑ ÑÐ¸ÑÐ»Ð¸ÑÑÑÑ Ð·Ð° Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ð¼Ð¸ ÐÐ¦), Ð° ÑÑÑ Ð½ÑÐ¶ÐµÐ½ ÑÐ¾Ð²Ð½Ð¾ Ð¾Ð´Ð¸Ð½.
// Ð¡Ð¿Ð¸ÑÐ¾Ðº ÐÐ¦ Ð³ÑÑÐ·Ð¸ÑÑÑ ÐÐÐÐÐÐ Ð¿Ð¾ ÑÐ¾ÐºÑÑÑ (ÐºÐ°Ðº SelectMarks/SelectModels/SelectCity),
// Ð° Ð½Ðµ ÑÑÐ°Ð·Ñ Ð¿ÑÐ¸ ÑÐµÐ·Ð¾Ð»Ð²Ðµ Ð³Ð¾ÑÐ¾Ð´Ð°/Ð¼Ð°ÑÐºÐ¸ â Ð¸Ð½Ð°ÑÐµ Ð½Ð° Ð´ÐµÑÑÑÐºÐ°Ñ ÑÑÑÐ¾Ðº Ñ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼
// Ð·Ð°ÑÐ°Ð½ÐµÐµ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÐµÐ½Ð½ÑÐ¼ Ð³Ð¾ÑÐ¾Ð´Ð¾Ð¼+Ð¼Ð°ÑÐºÐ¾Ð¹ Ð¾Ð´Ð½Ð¾Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾ Ð»ÐµÑÐ¸Ñ ÐºÑÑÐ° Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÑ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð².
// dcCache â Ð¾Ð±ÑÐ¸Ð¹ Ð½Ð° Ð²ÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ ÐºÑÑ (Ð³Ð¾ÑÐ¾Ð´+Ð¼Ð°ÑÐºÐ° Ð¾Ð±ÑÑÐ½Ð¾ Ð¿Ð¾Ð²ÑÐ¾ÑÑÑÑÑÑ Ð² ÑÐ°Ð·Ð½ÑÑ
// ÑÑÑÐ¾ÐºÐ°Ñ Ð¾Ð´Ð½Ð¾Ð³Ð¾ ÑÐ°Ð¹Ð»Ð°), ÑÑÐ¾Ð±Ñ Ð½Ðµ ÑÑÐ½ÑÑÑ Ð¾Ð´Ð¸Ð½ Ð¸ ÑÐ¾Ñ Ð¶Ðµ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾ Ð½Ð¾Ð²Ð¾Ð¹
const RowDcSelect = ({ value, onChange, dependantValue, label, placeholder, error, required, dcCache }) => {
  const cityOption = dependantValue?.[0];
  const markOption = dependantValue?.[1];
  const cityId = cityOption?.value;
  const mark = markOption?.label;
  const depKey = `${cityId || ''}|${mark || ''}`;

  const [options, setOptions] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const isFirstRun = useRef(true);

  // Ð¡Ð±ÑÐ¾Ñ Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ Ð³Ð¾ÑÐ¾Ð´Ð°/Ð¼Ð°ÑÐºÐ¸ â Ð±ÐµÐ· ÑÐµÑÐ¸, ÑÐ°Ð¼Ð° Ð·Ð°Ð³ÑÑÐ·ÐºÐ° Ð¸Ð´ÑÑ Ð¿Ð¾ ÑÐ¾ÐºÑÑÑ
  React.useEffect(() => {
    setOptions([]);
    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else if (onChange) {
      onChange(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depKey]);

  const loadOptions = () => {
    if (!cityId || isLoading || options.length > 0) return;

    const cached = dcCache?.get(depKey);
    if (cached) {
      setOptions(cached);
      return;
    }

    setIsLoading(true);
    getDcList({ cityId, mark })
      .then((res) => {
        const opts = (res?.data || []).map((item) => ({ value: item.id, label: item.name }));
        dcCache?.set(depKey, opts);
        setOptions(opts);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Select
      title={label || 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ'}
      placeholder={cityId ? placeholder || 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' : 'Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð³Ð¾ÑÐ¾Ð´'}
      options={options}
      value={value}
      isLoading={isLoading}
      isSearchable
      disabled={!cityId}
      error={error}
      required={required}
      onChange={onChange}
      onFocus={loadOptions}
    />
  );
};

// Ð¤Ð¾ÑÐ¼Ð° Ð¾Ð´Ð½Ð¾Ð¹ "Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ð½Ð¾Ð¹" ÑÑÑÐ¾ÐºÐ¸ ÑÑÐ¾ÐºÐ° â ÑÐµ Ð¶Ðµ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½ÑÐµ ÑÐµÐ»ÐµÐºÑÑ, ÑÑÐ¾ Ð¸ Ð² ÑÐ¾ÑÐ¼Ðµ
// ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð°Ð²ÑÐ¾ (pages/Car/CarMainData.jsx). ÐÐ°ÑÐºÑ/Ð³Ð¾ÑÐ¾Ð´ Ð¼Ð°ÑÑÐ¸Ð¼ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð½Ð¾ Ð¿Ð¾
// ÑÐ¿Ð¸ÑÐºÐ°Ð¼, Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÐ¼ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð· Ð½Ð° Ð²ÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ (Ð±ÐµÐ· ÑÐµÑÐ¸). ÐÐ¾Ð´ÐµÐ»Ñ/ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ/ÐÐ¦
// ÐÐ Ð¿ÑÑÐ°ÐµÐ¼ÑÑ ÑÐ³Ð°Ð´Ð°ÑÑ Ð·Ð°ÑÐ°Ð½ÐµÐµ â Ð¾Ð½Ð¸ ÑÐµÑÐ½Ð¾ ÑÐ²ÑÐ·Ð°Ð½Ñ Ñ Ð¼Ð°ÑÐºÐ¾Ð¹/Ð¼Ð¾Ð´ÐµÐ»ÑÑ Ð¸ Ð³ÑÑÐ·ÑÑÑÑ Ð»ÐµÐ½Ð¸Ð²Ð¾
// ÑÐµÐ¼Ð¸ Ð¶Ðµ ÑÐµÐ»ÐµÐºÑÐ°Ð¼Ð¸, ÑÑÐ¾ Ð¸ Ð²ÐµÐ·Ð´Ðµ, ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð³Ð´Ð° Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð¸Ñ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ â
// Ð¸Ð½Ð°ÑÐµ Ð½Ð° Ð´ÐµÑÑÑÐºÐ¸ ÑÑÑÐ¾Ðº ÑÑÐ°Ð·Ñ Ð»ÐµÑÐ¸Ñ ÐºÑÑÐ° Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð²
const PendingRowForm = ({
  row,
  allCities,
  allMarks,
  origin,
  onSubmitRow,
  dcCache,
  createdModels,
  onModelCreated,
}) => {
  const resolvedContainerIdRef = useRef(null);
  const hookFormRef = useRef(null);
  const [modelModalOpen, setModelModalOpen] = useState(false);

  // ÐÑÐº ÑÐ¶Ðµ ÑÐµÐ·Ð¾Ð»Ð²Ð¸Ñ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸ Ð¿Ð¾ ÑÐ¾Ð´Ñ Ð¿Ð°ÑÑÐ¸Ð½Ð³Ð° ÑÑÑÐ¾ÐºÐ¸ Ð¸ Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ id ÑÐ¾Ð³Ð¾, ÑÑÐ¾
  // ÑÑÐ¿ÐµÐ»Ð¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑÑÑ Ð´Ð¾ Ð¼Ð¾Ð¼ÐµÐ½ÑÐ° Ð¾ÑÐºÐ»Ð¾Ð½ÐµÐ½Ð¸Ñ (resolvedMarkId/resolvedCityId/
  // resolvedDcId/resolvedModelId) â ÑÑÐ¾ Ð½Ð°Ð´ÑÐ¶Ð½ÐµÐµ, ÑÐµÐ¼ Ð½ÐµÑÑÑÐºÐ¾Ðµ ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð¿Ð¾
  // Ð¸Ð¼ÐµÐ½Ð¸ Ð½Ð° ÑÑÐ¾Ð½ÑÐµ, Ð¸ Ð½Ðµ ÑÑÐµÐ±ÑÐµÑ Ð»Ð¸ÑÐ½Ð¸Ñ ÑÐµÑÐµÐ²ÑÑ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð². Ð¤Ð¾Ð»Ð»Ð±ÑÐº Ð½Ð°
  // ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð¿Ð¾ Ð¸Ð¼ÐµÐ½Ð¸ Ð¾ÑÑÐ°ÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Ð¿Ð¾Ð»ÐµÐ¹, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð±ÑÐº Ð½Ðµ ÑÐµÐ·Ð¾Ð»Ð²Ð¸Ð»
  // (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ ÑÑÑÐ¾ÐºÐ° Ð¾ÑÐºÐ»Ð¾Ð½ÐµÐ½Ð° ÐµÑÑ Ð´Ð¾ ÑÐµÐ·Ð¾Ð»Ð²Ð¸Ð½Ð³Ð° ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¾Ð²)
  const defaults = useMemo(() => {
    const cityByName = findByName(allCities, row.cityName, 'title');
    const cityMatch = row.resolvedCityId
      ? { value: row.resolvedCityId, label: row.cityName }
      : cityByName
      ? { value: cityByName.id, label: cityByName.title }
      : null;
    const markByName = findByName(allMarks, row.markName, 'name');
    const markMatch = row.resolvedMarkId
      ? { value: row.resolvedMarkId, label: row.markName }
      : markByName
      ? { value: markByName.id, label: markByName.name }
      : null;
    const dcMatch = row.resolvedDcId ? { value: row.resolvedDcId, label: row.dcName } : null;
    const modelMatch = row.resolvedModelId
      ? { value: row.resolvedModelId, label: row.modelName }
      : null;
    // ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ â ÑÐ²Ð¾Ð±Ð¾Ð´Ð½ÑÐ¹ ÑÐµÐºÑÑ (Ð±ÑÐº Ð¼Ð°ÑÑÐ¸Ñ/ÑÐ¾Ð·Ð´Ð°ÑÑ ÐµÑ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ ÑÐ°Ð¼,
    // Ð±ÐµÐ· Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ Ð¿Ð¾ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÑ) â Ð² Ð¾ÑÐ»Ð¸ÑÐ¸Ðµ Ð¾Ñ Ð¼Ð°ÑÐºÐ¸/Ð¼Ð¾Ð´ÐµÐ»Ð¸/Ð³Ð¾ÑÐ¾Ð´Ð°/ÐÐ¦ ÐµÑ
    // Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾ Ð´Ð¾Ð¶Ð¸Ð´Ð°ÑÑÑÑ ÑÐµÐ·Ð¾Ð»Ð²Ð¸Ð½Ð³Ð° Ð¼Ð¾Ð´ÐµÐ»Ð¸: ÑÐ¾, ÑÑÐ¾ ÑÐ°ÑÐ¿Ð°ÑÑÐ¸Ð»Ð¾ÑÑ Ð¸Ð· ÑÐ°Ð¹Ð»Ð°,
    // Ð¿ÑÐµÐ´Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÐµÐ¼ Ð²ÑÐµÐ³Ð´Ð°, Ð´Ð°Ð¶Ðµ ÐµÑÐ»Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ ÐµÑÑ Ð¿ÑÐµÐ´ÑÑÐ¾Ð¸Ñ Ð²ÑÐ±ÑÐ°ÑÑ/Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ
    // Ð²ÑÑÑÐ½ÑÑ
    const complectMatch = row.complectationName
      ? { value: 0, label: row.complectationName }
      : null;
    const colorMatch = row.color
      ? COLORS.find((c) => c.label.toLowerCase() === row.color.toLowerCase())
      : null;
    const engineTypeMatch = row.engineType
      ? ENGINE_TYPE_OPTIONS.find((o) => o.label.toLowerCase() === row.engineType.toLowerCase())
      : null;
    // ÐÐ¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÑÐ¾Ð²Ð½Ð¾ ÑÐ¾, ÑÑÐ¾ Ð¿ÑÐ¸ÑÐ»Ð¾ Ð¸Ð· ÑÐ°Ð¹Ð»Ð°, Ð½Ðµ ÑÐ²ÐµÑÑÑÑÑ ÑÐ¾ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¾Ð¼:
    // ÑÐ¿Ð¸ÑÐ¾Ðº Ð³ÑÑÐ·Ð¸ÑÑÑ Ð»ÐµÐ½Ð¸Ð²Ð¾ Ð¿Ð¾ ÑÐ¾ÐºÑÑÑ, Ð° ÑÐ²ÐµÑÐºÐ° Ð²ÑÑ ÑÐ°Ð²Ð½Ð¾ Ð½Ð° Ð±ÑÐºÐµ. ÐÐ°Ð¾Ð´Ð½Ð¾ Ð½Ðµ
    // ÑÐµÑÑÐµÑÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ Ð½ÐµÑ, â Ð¾Ð¿ÐµÑÐ°ÑÐ¾Ñ ÐµÐ³Ð¾ ÑÐ²Ð¸Ð´Ð¸Ñ
    const transmissionMatch = row.transmission
      ? { value: row.transmission, label: row.transmission }
      : null;

    return {
      mark: markMatch,
      model: modelMatch,
      complect: complectMatch,
      city: cityMatch,
      dc: dcMatch,
      color: colorMatch,
      engineType: engineTypeMatch,
      transmission: transmissionMatch,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ÐÐ°ÑÐºÐ°, Ð²ÑÐ±ÑÐ°Ð½Ð½Ð°Ñ Ð¿ÑÑÐ¼Ð¾ ÑÐµÐ¹ÑÐ°Ñ Ð² ÑÐ¾ÑÐ¼Ðµ â Ð½ÑÐ¶Ð½Ð° Ð¼Ð¾Ð´Ð°Ð»ÐºÐµ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ Ð¼Ð¾Ð´ÐµÐ»Ð¸,
  // ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¸Ð²ÑÐ·Ð°ÑÑ Ð½Ð¾Ð²ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ Ðº ÑÐ¾Ð¼Ñ, ÑÑÐ¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð²ÑÐ±ÑÐ°Ð», Ð° Ð½Ðµ
  // ÑÐ¾Ð»ÑÐºÐ¾ Ðº ÑÐ¾Ð¼Ñ, ÑÑÐ¾ ÑÐ°ÑÐ¿Ð¾Ð·Ð½Ð°Ð»Ð¾ÑÑ Ð¿ÑÐ¸ Ð¿Ð°ÑÑÐ¸Ð½Ð³Ðµ ÑÐ°Ð¹Ð»Ð°
  const [liveMark, setLiveMark] = useState(defaults.mark || null);

  const resolveContainerId = async ({ markOption, modelOption }) => {
    if (!markOption?.label || !modelOption?.label) {
      resolvedContainerIdRef.current = null;
      return;
    }
    try {
      const query = `${markOption.label} ${modelOption.label}`;
      const res = await getContainers({ markAndModel: query, page: 1 });
      resolvedContainerIdRef.current = res?.data?.containers?.[0]?.id ?? null;
    } catch (e) {
      resolvedContainerIdRef.current = null;
    }
  };

  // ÐÐ¾Ð´ÐµÐ»Ñ Ð¿ÑÐµÐ´Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð° Ð±ÑÐºÐ¾Ð¼ (ÑÐµÐ´ÐºÐ¸Ð¹ ÑÐ»ÑÑÐ°Ð¹ â Ð±ÑÐº ÑÐµÐ·Ð¾Ð»Ð²Ð¸Ñ ÐµÑ Ð»Ð¸ÑÑ ÐºÐ¾Ð³Ð´Ð°
  // Ð¾ÑÑÐ°Ð»ÑÐ½Ð¾Ðµ ÑÐ¾Ð¶Ðµ ÑÐ¾ÑÐ»Ð¾ÑÑ) â Ð¿Ð¾Ð´ÑÑÐ³Ð¸Ð²Ð°ÐµÐ¼ containerId ÑÑÐ°Ð·Ñ, Ð¸Ð½Ð°ÑÐµ Ð¾ÑÐºÑÑÑÐ¸Ðµ
  // ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð½Ðµ Ð½Ð°Ð¹Ð´ÑÑ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ¾Ð², Ð¿Ð¾ÐºÐ° Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð½Ðµ ÑÑÐ¾Ð½ÐµÑ Ð¼Ð°ÑÐºÑ/Ð¼Ð¾Ð´ÐµÐ»Ñ
  useEffect(() => {
    if (defaults.mark && defaults.model) {
      resolveContainerId({ markOption: defaults.mark, modelOption: defaults.model });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const inputs = [
    {
      name: 'mark',
      component: SelectMarks,
      label: 'ÐÐ°ÑÐºÐ°',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      defaultValue: defaults.mark,
      rules: { required: true },
      onChangeCustom: (val) => {
        resolvedContainerIdRef.current = null;
        setLiveMark(val);
      },
    },
    {
      name: 'model',
      component: SelectModels,
      dependency: 'mark',
      dependencyAccessor: (o) => o?.value,
      label: 'ÐÐ¾Ð´ÐµÐ»Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      defaultValue: defaults.model,
      rules: { required: true },
      onChangeCustom: (modelOption, markOption) => resolveContainerId({ markOption, modelOption }),
    },
    {
      name: 'complect',
      component: SelectComplectations,
      dependency: ['mark', 'model'],
      dependencyAccessor: (arr) => arr?.map((o) => o?.value).join('|'),
      label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
      defaultValue: defaults.complect,
      rules: { required: true },
      params: () => resolvedContainerIdRef.current,
      // ÐÑÐº Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð»ÑÐ½Ð¾Ðµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð¸ ÑÐ°Ð¼ Ð·Ð°Ð²Ð¾Ð´Ð¸Ñ ÐµÑ,
      // ÐµÑÐ»Ð¸ ÑÐ°ÐºÐ¾Ð¹ ÐµÑÑ Ð½ÐµÑ â Ð°ÐºÑÑÐ°Ð»ÑÐ½Ð¾ Ð¿ÑÐµÐ¶Ð´Ðµ Ð²ÑÐµÐ³Ð¾ Ð´Ð»Ñ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾ ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ð¹
      // Ð¼Ð¾Ð´ÐµÐ»Ð¸ (Ñ Ð½ÐµÑ ÑÐ¸Ð·Ð¸ÑÐµÑÐºÐ¸ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð³Ð¾ÑÐ¾Ð²ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¹ Ð²
      // ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ). creatable Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð²Ð²ÐµÑÑÐ¸ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÑÐºÐ°Ð¼Ð¸, ÐµÑÐ»Ð¸ ÐµÐ³Ð¾
      // Ð½ÐµÑ ÑÑÐµÐ´Ð¸ Ð¿Ð¾Ð´Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÑ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ¾Ð², Ð²Ð¼ÐµÑÑÐ¾ ÑÑÐ¿Ð¸ÐºÐ° "No options"
      creatable: true,
      isSearchable: true,
      formatCreateLabel: (input) => `Ð£ÐºÐ°Ð·Ð°ÑÑ Â«${input}Â» ÐºÐ°Ðº Ð½Ð¾Ð²ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ`,
    },
    { name: 'vin', label: 'VIN', defaultValue: row.vin, rules: { required: true } },
    { component: SelectColor, name: 'color', label: 'Ð¦Ð²ÐµÑ ÐºÑÐ·Ð¾Ð²Ð°', defaultValue: defaults.color },
    { name: 'engineVolume', label: 'ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', defaultValue: row.engineVolume },
    {
      component: Select,
      name: 'engineType',
      label: 'Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
      placeholder: 'ÐÐµ Ð²Ð°Ð¶Ð½Ð¾',
      options: ENGINE_TYPE_OPTIONS,
      defaultValue: defaults.engineType,
    },
    {
      component: RowTransmissionSelect,
      name: 'transmission',
      label: 'ÐÐÐ',
      placeholder: 'ÐÐµ Ð²Ð°Ð¶Ð½Ð¾',
      defaultValue: defaults.transmission,
    },
    {
      name: 'price',
      label: 'Ð Ð Ð¦, KZT',
      defaultValue: row.priceStr,
      format: 'number',
      rules: { required: true },
    },
    { name: 'issueYear', label: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°', defaultValue: row.yearStr, rules: { required: true } },
    {
      component: SelectCity,
      name: 'city',
      label: 'ÐÐ¾ÑÐ¾Ð´',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      defaultValue: defaults.city,
      rules: { required: true },
    },
    {
      component: RowDcSelect,
      name: 'dc',
      dependency: ['city', 'mark'],
      dependencyAccessor: (arr) => arr,
      label: 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ',
      defaultValue: defaults.dc,
      rules: { required: true },
      dcCache,
    },
  ];

  const [submitting, setSubmitting] = useState(false);
  const [modelCreated, setModelCreated] = useState(false);

  // ÐÐ¾Ð´ÐµÐ»Ñ Ð¸Ð· ÑÐ°Ð¹Ð»Ð° Ð½Ðµ Ð½Ð°ÑÐ»Ð°ÑÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ â Ð²Ð¼ÐµÑÑÐ¾ ÑÐ¾Ð³Ð¾ ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¾ÑÑÐ¾ Ð¾ÑÑÐ°Ð²Ð¸ÑÑ
  // ÑÐµÐ»ÐµÐºÑ Ð¿ÑÑÑÑÐ¼, Ð´Ð°ÑÐ¼ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑ ÑÑÑ Ð¶Ðµ Ð¸ ÑÑÐ°Ð·Ñ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð¸ÑÑ Ð² ÑÐ¾ÑÐ¼Ñ (Ð±ÐµÐ·
  // Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÑÑÐ¾ÐºÐ¸ Ð¸ Ð±ÐµÐ· Ð¿Ð¾ÑÐ¾Ð´Ð° Ð½Ð° Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ /cars/models)
  const handleModelCreated = (modelOption) => {
    hookFormRef.current?.setValue('model', modelOption);
    resolveContainerId({ markOption: liveMark, modelOption });
    setModelCreated(true);
    onModelCreated && onModelCreated(liveMark?.value, modelOption);
  };

  // Ð¢Ñ Ð¶Ðµ Ð½ÐµÐ´Ð¾ÑÑÐ°ÑÑÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¼Ð¾Ð³Ð»Ð¸ ÑÐ¶Ðµ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð² Ð´ÑÑÐ³Ð¾Ð¹ ÑÑÑÐ¾ÐºÐµ Ñ ÑÐ°ÐºÐ¾Ð¹ Ð¶Ðµ
  // Ð¾ÑÐ¸Ð±ÐºÐ¾Ð¹ (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ ÑÑÑÐ¾ÐºÐ° 247 ÑÐ¾Ð·Ð´Ð°Ð»Ð° "Soul" Ð´Ð»Ñ KIA) â Ð¿Ð¾Ð´ÑÐ²Ð°ÑÑÐ²Ð°ÐµÐ¼ ÐµÑ Ð¸
  // ÑÑÑ, Ð²Ð¼ÐµÑÑÐ¾ ÑÐ¾Ð³Ð¾ ÑÑÐ¾Ð±Ñ Ð·Ð°ÑÑÐ°Ð²Ð»ÑÑÑ Ð¸ÑÐºÐ°ÑÑ/Ð´Ð¾Ð±Ð°Ð²Ð»ÑÑÑ Ð¿Ð¾ Ð½Ð¾Ð²Ð¾Ð¹ Ð½Ð° ÐºÐ°Ð¶Ð´Ð¾Ð¹ ÑÑÑÐ¾ÐºÐµ
  useEffect(() => {
    if (!liveMark?.value || !row.modelName || defaults.model || modelCreated) return;
    const key = `${liveMark.value}|${row.modelName.toLowerCase()}`;
    const match = createdModels?.[key];
    if (match) {
      hookFormRef.current?.setValue('model', match);
      resolveContainerId({ markOption: liveMark, modelOption: match });
      setModelCreated(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdModels, liveMark, modelCreated]);

  // ÐÐ¾Ð´ÐµÐ»Ñ Ð¼Ð¾Ð³Ð»Ð° Ð¾ÑÑÐ°ÑÑÑÑ Ð½ÐµÑÐµÐ·Ð¾Ð»Ð²Ð»ÐµÐ½Ð½Ð¾Ð¹ (resolvedModelId=null) Ð¿ÑÐ¾ÑÑÐ¾ Ð¿Ð¾ÑÐ¾Ð¼Ñ,
  // ÑÑÐ¾ Ð±ÑÐº ÑÐ¿Ð¾ÑÐºÐ½ÑÐ»ÑÑ ÑÐ°Ð½ÑÑÐµ â Ð½Ð° Ð³Ð¾ÑÐ¾Ð´Ðµ/ÐÐ¦/Ð¼Ð°ÑÐºÐµ â Ð¸ Ð´Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð´ÐµÐ»Ð¾
  // Ð²Ð¾Ð¾Ð±ÑÐµ Ð½Ðµ Ð´Ð¾ÑÐ»Ð¾, Ð° Ð½Ðµ Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ ÐµÑ ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð½ÐµÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ (ÑÐ¼. Ð¿Ð¾ÑÑÐ´Ð¾Ðº
  // ÑÐµÐ·Ð¾Ð»Ð²Ð¸Ð½Ð³Ð° Ð² uploadStockFromExcel: Ð³Ð¾ÑÐ¾Ð´ â ÐÐ¦ â Ð¼Ð°ÑÐºÐ° â Ð¼Ð¾Ð´ÐµÐ»Ñ). ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼
  // "+ ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ" ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð³Ð´Ð° Ð¾ÑÐ¸Ð±ÐºÐ° ÑÑÑÐ¾ÐºÐ¸ Ð¿ÑÑÐ¼Ð¾ Ð½Ð°Ð·ÑÐ²Ð°ÐµÑ Ð¼Ð¾Ð´ÐµÐ»Ñ
  // Ð½ÐµÐ½Ð°Ð¹Ð´ÐµÐ½Ð½Ð¾Ð¹, Ð° Ð½Ðµ Ð¿ÑÐ¸ Ð»ÑÐ±Ð¾Ð¼ Ð¾ÑÑÑÑÑÑÐ²Ð¸Ð¸ resolvedModelId
  const modelNotFoundError = row.errors?.some((msg) => /ÐÐ¾Ð´ÐµÐ»Ñ .* Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð°/i.test(msg));
  const showAddModelAction = !defaults.model && modelNotFoundError && !modelCreated && row.modelName && liveMark;

  const handleSubmit = async (payload) => {
    // ÐÐ»Ð¾ÐºÐ¸ÑÑÐµÐ¼ ÐºÐ½Ð¾Ð¿ÐºÑ Ð½Ð° Ð²ÑÐµÐ¼Ñ Ð·Ð°Ð¿ÑÐ¾ÑÐ° â Ð¸Ð½Ð°ÑÐµ Ð´Ð²Ð¾Ð¹Ð½Ð¾Ð¹ ÐºÐ»Ð¸Ðº/Ð´Ð²Ð° Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð¿Ð¾Ð´ÑÑÐ´
    // Ð¼Ð¾Ð³ÑÑ ÑÐ¾Ð·Ð´Ð°ÑÑ Ð¾Ð´Ð½Ð¾ Ð¸ ÑÐ¾ Ð¶Ðµ Ð°Ð²ÑÐ¾ Ð´Ð²Ð°Ð¶Ð´Ñ (Ð±ÑÐº Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ VIN,
    // Ð½Ð¾ ÑÑÐ¾ Ð»Ð¸ÑÐ½Ð¸Ð¹ Ð¿Ð¾Ð²Ð¾Ð´ Ð´Ð»Ñ Ð³Ð¾Ð½ÐºÐ¸, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐµ Ð½Ðµ Ð´Ð¾Ð¿ÑÑÐºÐ°ÑÑ Ð½Ð° ÑÑÐ¾Ð½ÑÐµ)
    setSubmitting(true);
    try {
      await onSubmitRow({
        // fileName + row = Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ½Ð¾ÑÑÑ ÑÑÑÐ¾ÐºÐ¸ Ð² ÑÐµÑÑÐ¸Ð¸ Ð¿ÑÐ°Ð²ÐºÐ¸ (Ð² Ð¼ÑÐ»ÑÑÐ¸ÑÐ°Ð¹Ð»Ð¾Ð²Ð¾Ð¹
        // Ð¿Ð°ÑÐºÐµ Ð³Ð¾Ð»ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ ÑÑÑÐ¾ÐºÐ¸ Ð½Ðµ ÑÐ½Ð¸ÐºÐ°Ð»ÐµÐ½)
        fileName: row.fileName || null,
        row: row.row,
        markId: payload.mark?.value,
        modelId: payload.model?.value,
        complectationTitle: payload.complect?.label || '',
        cityId: payload.city?.value,
        dcId: payload.dc?.value,
        vin: (payload.vin || '').trim(),
        color: payload.color?.value || '',
        engineVolume: payload.engineVolume || '',
        engineType: payload.engineType?.label || null,
        transmission: payload.transmission?.value || null,
        priceStr: (payload.price || '').replace(/\s/g, ''),
        issueYear: payload.issueYear || '',
        ...decomposeOrigin(origin),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.row}>
      {row.errors?.length > 0 && (
        <div className={styles.rowErrors}>
          {row.errors.map((msg, i) => (
            <div key={i} className={styles.rowError}>
              {msg}
            </div>
          ))}
        </div>
      )}
      {showAddModelAction && (
        <button
          type="button"
          className={styles.addModelButton}
          onClick={() => setModelModalOpen(true)}
        >
          + ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ Â«{row.modelName}Â»
        </button>
      )}
      <HookForm
        ref={hookFormRef}
        inputs={inputs}
        grid={{
          display: 'grid',
          gap: '16px',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          alignItems: 'flex-end',
        }}
        action="ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÑÑÐ¾ÐºÑ"
        onSubmit={handleSubmit}
        loading={submitting}
      />
      <AddModelModal
        isOpen={modelModalOpen}
        onClose={() => setModelModalOpen(false)}
        markId={liveMark?.value}
        markLabel={liveMark?.label}
        initialName={row.modelName}
        onCreated={handleModelCreated}
      />
    </div>
  );
};

export default PendingRowForm;
